import React from 'react';
import { Rnd } from "react-rnd";
import type { LTWHP, ViewportHighlight } from "../types";
import "./css/style.css";

interface Props {
    highlight: ViewportHighlight;
    onChange: (rect: LTWHP) => void;
    isScrolledTo: boolean;
}

export const AreaHighlight = ({
    highlight,
    onChange,
    isScrolledTo,
    ...otherProps
}: Props) => (
    <div
        className={`areaHighlight ${isScrolledTo ? "scrolledTo" : ""}`}
    >
        <Rnd
            className="part"
            onDragStop={(_, data) => {
                const boundingRect: LTWHP = {
                    ...highlight.position.boundingRect,
                    top: data.y,
                    left: data.x,
                };
                onChange(boundingRect);
            }}
            onResizeStop={(_mouseEvent, _direction, ref, _delta, position) => {
                const boundingRect: LTWHP = {
                    top: position.y,
                    left: position.x,
                    width: ref.offsetWidth,
                    height: ref.offsetHeight,
                    pageNumber: highlight.position.boundingRect.pageNumber || 0,
                };
                onChange(boundingRect);
            }}
            position={{
                x: highlight.position.boundingRect.left,
                y: highlight.position.boundingRect.top,
            }}
            size={{
                width: highlight.position.boundingRect.width,
                height: highlight.position.boundingRect.height,
            }}
            onClick={(event: React.MouseEvent) => {
                event.stopPropagation();
                event.preventDefault();
            }}
            {...otherProps}
        />
    </div>
);
